<template>
  <div class="Order">
    <PageTitle title="Order History" />
    <div v-for="(order, idx) in allOrders" :key="idx">
      <div class="pa-4">
        <div class="d-flex justify-space-between">
          <span class="text-subtitle-2 font-weight-bold">
            Order #{{ order.id }}
          </span>
          <span
            v-if="order.points_paid"
            class="text-subtitle-2 font-weight-bold"
          >
            -{{ order.points_paid }} pts
          </span>
          <span v-else>Paid With Cash</span>
        </div>
        <div class="d-flex justify-space-between">
          <span class="text-caption font-weight-light">
            {{ $moment(order.purchased_at).format('dddd, MMMM Do, YYYY') }}
          </span>
          <router-link
            class="text-decoration-underline text-black text-caption"
            :to="{
              name: 'OrderDetails',
              params: {
                orderId: order.id
              },
              query: {
                t: $route.query.t,
                type: checkOrderProducts(order)
              }
            }"
          >
            <div>
              View Details
              <icon class="ms-1" height="6" width="6">angle-right</icon>
            </div>
          </router-link>
        </div>
        <div class="d-flex justify-space-between mt-3">
          <div v-for="(img, idx) in getMedia(order)" :key="idx">
            <v-img
              v-if="img && idx < 1"
              alt="order-history-deal"
              class="rounded-lg me-2"
              height="58"
              width="115"
              cover
              :src="img.url"
            ></v-img>
          </div>
          <div
            v-if="getMedia(order).length > 1"
            class="font-weight-bold bg-grey-lighten-4 pa-4 rounded-lg text-body-2"
          >
            +{{ getMedia(order).length - 1 }}
          </div>
          <v-btn
            v-if="pickupInOrder(order) && !checkOrderItemRedeemed(order)"
            class="text-white"
            color="blue"
            rounded
            size="small"
            variant="flat"
            :to="{
              name: 'OrderDetails',
              params: {
                orderId: order.id
              },
              query: {
                t: $route.query.t,
                type: checkOrderProducts(order)
              }
            }"
          >
            Pending Pickup
          </v-btn>
        </div>
      </div>
      <v-divider class="my-0"></v-divider>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PageTitle from '@/components/shared/PageTitle/index.vue';
import { pascalCase } from '../../../helpers';

export default {
  name: 'OrderHistory',
  components: {
    PageTitle
  },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    ...mapActions('orders', ['getOrderHistory']),
    checkOrderProducts(order) {
      return order.products.length > 0 ? 'products' : 'deals';
    },

    getMedia(order) {
      const { products, deals } = order;

      const productMedia = products.reduce(
        (acc, product) =>
          product?.media?.length > 0
            ? [...acc, product.media.find(m => m.name === 'Hero')]
            : acc,
        []
      );

      const dealMedia = deals.reduce(
        (acc, deal) =>
          deal?.media?.length > 0
            ? [...acc, deal.media.find(m => m.name === 'Hero')]
            : acc,
        []
      );

      const groupedMedia = [...dealMedia, ...productMedia];
      const normalizedMedia = groupedMedia
        .map(media => {
          if (!media) return null;
          const url =
            media.url ||
            media.src ||
            media.path ||
            media.image ||
            media.cloudinary_url ||
            null;
          return url ? { url } : null;
        })
        .filter(Boolean);
      if (normalizedMedia.length === 0) {
        return [
          {
            url:
              'https://res.cloudinary.com/bandwango/image/upload/v1651182813/noimage_vsnmt3.webp'
          }
        ];
      }
      return normalizedMedia;
    },

    checkOrderItemRedeemed(order) {
      const orderItems = this.findOrderItems(order);
      return orderItems[0]?.redeemed;
    },

    pickupInOrder(order) {
      // loop through the order and find if any in htere are pickup. if it is. its true;
      return ['deals', 'packages', 'products'].some(type =>
        order?.[`order${pascalCase(type)}`]?.some(
          item => item?.delivery_method === 'picked_up'
        )
      );
      // if (order.products.length > 0) {
      //   const h = order.products[0].order_products.some(
      //     orderProduct => orderProduct.delivery_method === 'picked_up'
      //   );
      //   return h;
      // }
    }
  },
  computed: {
    ...mapGetters('orders', {
      allOrders: 'list',
      findOrderItems: 'findOrderItems'
    }),
    ...mapState(['offer', 'orders', 'partnerUser'])
  },
  async created() {
    const res = await this.getOrderHistory({
      partnerUserId: this.partnerUser.id,
      params: { offerId: this.offer.id, display: 20, page: 1 }
    });
    if (res.status === 200) this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
:deep(.v-divider) {
  border-color: rgba(var(--v-theme-on-surface), var(--v-divider-opacity));
}
</style>
